import { useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import Model from "../../common/Model/index.js";
import { notify } from "../../common/Toast/index.js";
import { IoAdd } from "react-icons/io5";
import CRMSelect from "../../common/CustomSelect/CRMSelect.jsx";

const FinsMaterialItemTable = ({
  items,
  handleItemDelete,
  allItems,
  setItems,
  coatingColors,
  handleItemSelect,
  selectedCoatingPartyId,
  isCoatingModalOpen,
  setIsCoatingModalOpen,
  setCoatingColors,
  setIsItemModalOpen,
  isItemModalOpen,
  setAllItems,
  fetchDropdownData,
  errors,
  permission,
  itemPermission,
  coatingType,
}) => {
  const userId = localStorage.getItem("userId");

  const [newCoatingColor, setNewCoatingColor] = useState({
    coating_Color_Name: "",
    coating_Color_Code: "",
  });

  const [formData, setFormData] = useState({
    itemId: "",
    itemName: "",
    itemType: "",
    description: "",
    rate: "",
  });

  const [isEditingCoatingColor, setIsEditingCoatingColor] = useState(false);
  const [editCoatingColorId, setEditCoatingColorId] = useState(null);
  const filteredCoatingColors = coatingColors.filter(
    (color) => color.coating_Party_Id === Number(selectedCoatingPartyId)
  );

  const handleAddOrUpdateCoatingColor = async () => {
    try {
      const payload = {
        Coating_Color_Id: isEditingCoatingColor ? editCoatingColorId : 0,
        Coating_Party_Id: Number(selectedCoatingPartyId),
        Coating_Color_Name: newCoatingColor.coating_Color_Name,
        Coating_Color_Code: newCoatingColor.coating_Color_Code,
      };

      const apiUrl = isEditingCoatingColor
        ? "MaterialQuotation/UpdateCoatingColor"
        : "MaterialQuotation/SaveCoatingColor";

      await axiosInstance.post(apiUrl, payload);

      notify(
        isEditingCoatingColor
          ? "Coating Color updated successfully!"
          : "Coating Color added successfully!",
        "success"
      );

      fetchDropdownData(
        "MaterialQuotation/GetAllCoatingColors",
        setCoatingColors
      );
      if (isEditingCoatingColor) {
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.coating_Color_Id === editCoatingColorId
              ? { ...item, coating_Color_Id: editCoatingColorId }
              : item
          )
        );
      }

      setIsCoatingModalOpen(false);
      setNewCoatingColor({ coating_Color_Name: "", coating_Color_Code: "" });
      setIsEditingCoatingColor(false);
      setEditCoatingColorId(null);
    } catch (error) {
      console.error("Error adding/updating coating color:", error);
    }
  };

  const handleCoatingColorEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingColorById/${id}`
      );
      setNewCoatingColor({
        coating_Color_Name: data.coating_Color_Name,
        coating_Color_Code: data.coating_Color_Code,
      });
      setEditCoatingColorId(id);
      setIsEditingCoatingColor(true);
      setIsCoatingModalOpen(true);
    } catch (error) {
      console.error("Error fetching coating color:", error);
    }
  };

  const itemOptions = [
    ...allItems?.map((item) => ({
      value: item.itemId?.toString() || "",
      label: item.itemName || "Unnamed Item",
    })),
    ...(itemPermission.isInsert ? [{ value: "add-newItem", label: "+ Add New Item" }] : []),
  ];
  const colorOptions = [
    ...filteredCoatingColors.map((color) => ({
      value: color.coating_Color_Id,
      label: `${color.coating_Color_Name} `,
    })),
    ...(permission.isInsert ? [{ value: "add-new", label: "+ Add New Coating Color" }] : []),
  ];
  const coatingTypeOptions = [
    ...coatingType.map((type) => ({
      value: type.coatingTypeId,
      label: `${type.coatingType} `,
    })),
  ];


  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("FinsItem/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const handleItemSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        itemId: formData.itemId || 0,
        itemName: formData.itemName,
        description: formData.description,
        itemType: formData.itemType,
        rate: formData.rate,
        modifiedBy: userId,
        createdBy: userId,
      };

      await axiosInstance.post("FinsItem/SaveOrUpdate", payload);
      setIsItemModalOpen(false);
      fetchItemsData();
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <>
      <div className="bg-white rounded-[2rem] border border-slate-100 overflow-hidden shadow-sm">
        <div className="bg-slate-50/50 px-8 py-5 border-b border-slate-100 flex justify-between items-center">
          <h2 className="text-sm font-bold text-slate-700 uppercase tracking-widest flex items-center gap-2">
            Line Items & Materials
            <span className="bg-primary/10 text-primary text-[10px] px-2 py-0.5 rounded-full ml-1">
              {items?.length || 0}
            </span>
          </h2>
        </div>
        <div className="w-full overflow-x-auto max-h-[600px] overflow-y-auto relative custom-scrollbar">
          <table className="w-full text-left border-separate border-spacing-0 min-w-[1200px]">
            <thead className="sticky top-0 z-20">
              <tr className="bg-slate-50/95 backdrop-blur-md shadow-sm">
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-12 text-center">No</th>
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-[200px]">Item Details</th>
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-[180px]">Color</th>
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-[180px]">Finishing</th>
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-28 text-center">Panel Size</th>
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-28 text-center">Qty</th>
                <th className="px-2 py-3 text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-28 text-center">Total RFT</th>
                <th className="px-2 py-3 text-right text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-28">Rate</th>
                <th className="px-3 py-3 text-right text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-32">Amount</th>
                <th className="px-2 py-3 text-center text-[10px] font-black text-slate-600 uppercase tracking-widest border-b border-slate-100 w-24">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {items.map((item, index) => (
                <tr key={index} className="group hover:bg-slate-50/30 transition-all">
                  <td className="px-2 py-2 text-xs font-black text-slate-800 text-center">{item.seQ_NO}</td>

                  <td className="px-2 py-2">
                    <CRMSelect
                      options={itemOptions}
                      value={itemOptions.find(opt => String(opt.value) === String(items[index]?.itemId)) || null}
                      menuPortalTarget={document.body}
                      isClearable
                      isSearchable
                      onChange={(opt) => {
                        if (opt?.value === "add-newItem") {
                          setFormData({ itemId: "", itemName: "", itemType: "", description: "", rate: "" });
                          setIsItemModalOpen(true);
                        } else {
                          handleItemSelect(index, opt, "itemId");
                        }
                      }}
                    />
                  </td>

                  <td className="px-2 py-2">
                    <div className="flex items-center gap-1">
                      <div className="flex-1">
                        <CRMSelect
                          options={colorOptions}
                          value={colorOptions.find(opt => opt.value === items[index]?.coating_Color_Id) || null}
                          menuPortalTarget={document.body}
                          isClearable
                          isSearchable
                          placeholder="Color..."
                          onChange={(opt) => handleItemSelect(index, opt, "coating_Color_Id")}
                        />
                      </div>
                      {items[index]?.coating_Color_Id && (
                        <button
                          type="button"
                          onClick={() => handleCoatingColorEdit(items[index]?.coating_Color_Id)}
                          className="p-1 text-primary bg-primary/5 rounded-lg hover:bg-primary hover:text-white transition-all shadow-sm flex-shrink-0"
                        >
                          <MdModeEdit size={12} />
                        </button>
                      )}
                    </div>
                  </td>

                  <td className="px-2 py-2">
                    <CRMSelect
                      options={coatingTypeOptions}
                      value={coatingTypeOptions.find(opt => opt.value === items[index]?.coatingTypeId) || null}
                      menuPortalTarget={document.body}
                      isClearable
                      isSearchable
                      placeholder="Finishing..."
                      onChange={(opt) => handleItemSelect(index, opt, "coatingTypeId")}
                    />
                  </td>

                  <td className="px-2 py-2">
                    <input
                      className="w-full bg-slate-50 border border-slate-200 rounded-lg px-2 py-1.5 text-xs font-black text-slate-800 outline-none focus:bg-white focus:border-primary transition-all text-center"
                      name="panel_Size"
                      value={items[index]?.panel_Size || ""}
                      onChange={(e) => handleItemSelect(index, e)}
                      placeholder="Size MM"
                    />
                  </td>

                  <td className="px-2 py-2">
                    <input
                      className="w-full bg-slate-50 border border-slate-200 rounded-lg px-1 py-1.5 text-xs font-black text-slate-800 outline-none focus:bg-white focus:border-primary transition-all text-center"
                      name="qty"
                      value={items[index]?.qty || ""}
                      onChange={(e) => handleItemSelect(index, e)}
                      placeholder="QTY"
                    />
                  </td>

                  <td className="px-2 py-2">
                    <div className="bg-slate-100 border border-slate-200 rounded-lg px-2 py-1.5 text-center">
                      <span className="text-xs font-black text-slate-700 font-mono">{item.total_RFT.toFixed(2)}</span>
                    </div>
                  </td>

                  <td className="px-2 py-2">
                    <div className="relative">
                      <span className="absolute left-1.5 top-1.5 text-[8px] font-black text-slate-400">₹</span>
                      <input
                        type="text"
                        className="w-full bg-white border border-slate-200 rounded-lg pl-3 pr-1 py-1.5 font-black text-slate-800 outline-none focus:border-primary transition-all text-xs text-right"
                        name="rate"
                        value={items[index]?.rate || ""}
                        onChange={(e) => handleItemSelect(index, e)}
                        disabled={userId !== "1" && userId !== "19"}
                      />
                    </div>
                  </td>

                  <td className="px-2 py-2 text-right">
                    <span className="text-sm font-black text-slate-900 tracking-tight font-mono">₹{item.amount?.toLocaleString(undefined, { minimumFractionDigits: 0 })}</span>
                  </td>

                  <td className="px-2 py-2 text-center">
                    <button
                      type="button"
                      className="p-1.5 bg-primary/50 text-white rounded-lg hover:bg-primary transition-all active:scale-95 border border-red-100/50"
                      onClick={() =>
                        setItems((prevItems) => [
                          ...prevItems,
                          {
                            itemId: "",
                            itemName: "",
                            coating_Color_Id: "",
                            coatingTypeId: 1,
                            panel_Size: 0,
                            qty: 0,
                            total_RFT: 0,
                            rate: 0,
                            amount: 0,
                            seQ_NO: prevItems.length + 1,
                          },
                        ])
                      }
                    >
                      <IoAdd size={16} />
                    </button>
                    {permission?.isDelete && (
                      <button
                        type="button"
                        className="ml-2 p-1.5 bg-red-50 text-red-400 rounded-lg hover:bg-red-500 hover:text-white transition-all active:scale-95 border border-red-100/50"
                        onClick={() => handleItemDelete(index)}
                      >
                        <MdDeleteForever size={16} />
                      </button>
                    )}

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {errors.items && (
          <div className="bg-red-50 px-8 py-3 border-t border-red-100">
            <p className="text-red-500 text-[11px] font-bold flex items-center gap-2 italic">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span> {errors.items}
            </p>
          </div>
        )}
      </div >

      <Model
        isOpen={isCoatingModalOpen}
        onClose={() => setIsCoatingModalOpen(false)}
        name="Add Coating Color"
      >
        <div>
          <div className="space-y-4">
            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Color Name</label>
              <input
                type="text"
                placeholder="e.g. Traffic White"
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                value={newCoatingColor.coating_Color_Name}
                onChange={(e) => setNewCoatingColor((prev) => ({ ...prev, coating_Color_Name: e.target.value }))}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Color Code / RAL</label>
              <input
                type="text"
                placeholder="e.g. RAL 9016"
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                value={newCoatingColor.coating_Color_Code}
                onChange={(e) => setNewCoatingColor((prev) => ({ ...prev, coating_Color_Code: e.target.value }))}
              />
            </div>
          </div>
          <div className="flex items-center gap-3 pt-4">
            <button
              type="button"
              onClick={handleAddOrUpdateCoatingColor}
              className="flex-1 py-4 bg-primary text-white font-bold rounded-2xl shadow-lg shadow-primary/20 hover:shadow-xl transition-all active:scale-[0.98]"
            >
              {isEditingCoatingColor ? "Update Color" : "Save Color"}
            </button>
            <button
              type="button"
              onClick={() => setIsCoatingModalOpen(false)}
              className="flex-1 py-4 bg-slate-100 text-slate-500 font-bold rounded-2xl hover:bg-slate-200 transition-all active:scale-[0.98]"
            >
              Cancel
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={isItemModalOpen}
        onClose={() => setIsItemModalOpen(false)}
        name="Add New Item"
      >
        <div>
          <div className="space-y-4">
            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Item Category</label>
              <select
                className="w-full h-14 px-5 border border-slate-200 rounded-2xl bg-white font-semibold outline-none focus:border-primary transition-all appearance-none cursor-pointer"
                name="itemType"
                value={formData.itemType}
                onChange={(e) => setFormData((prev) => ({ ...prev, itemType: e.target.value }))}
              >
                <option value="">Select Category...</option>
                <option value="Aluminium">Aluminium</option>
                <option value="GI">GI</option>
              </select>
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Item Name</label>
              <input
                type="text"
                placeholder="Enter item name..."
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                value={formData.itemName}
                onChange={(e) => setFormData((prev) => ({ ...prev, itemName: e.target.value }))}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Description</label>
              <textarea
                placeholder="Technical specifications..."
                rows={3}
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold resize-none"
                value={formData.description}
                onChange={(e) => setFormData((prev) => ({ ...prev, description: e.target.value }))}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Standard Rate (Base)</label>
              <input
                type="number"
                placeholder="0.00"
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-bold text-lg"
                value={formData.rate}
                onChange={(e) => setFormData((prev) => ({ ...prev, rate: e.target.value }))}
              />
            </div>
          </div>

          <div className="flex items-center gap-3 pt-4">
            <button
              type="button"
              onClick={handleItemSubmit}
              className="flex-1 py-4 bg-primary text-white font-bold rounded-2xl shadow-lg shadow-primary/20 hover:shadow-xl transition-all active:scale-[0.98]"
            >
              {isEditingCoatingColor ? "Update Item" : "Create Item"}
            </button>
            <button
              type="button"
              onClick={() => setIsItemModalOpen(false)}
              className="flex-1 py-4 bg-slate-100 text-slate-500 font-bold rounded-2xl hover:bg-slate-200 transition-all active:scale-[0.98]"
            >
              Discard
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default FinsMaterialItemTable;
